import {
  VuexModule,
  mutation,
  action,
  getter,
  Module,
} from 'vuex-class-component';
import { vxm } from '@/store.vuex';
import axios from "axios";
import { UtmTrackerInfo } from "./utmtracker";

@Module({ namespacedPath: 'utmtracker/' })
export class UtmTrackerStore extends VuexModule {

  private trackerId: number = 0;

  public get utmTrackerId(): number {
    return this.trackerId;
  }

  @mutation
  public setUtmTrackerId(val: number) {
    this.trackerId = val;
  }

  @action({ mode: "mutate" })
  public async getUtmTrackerId(payload: UtmTrackerInfo) {
    console.log(payload, "getUtmTrackerId");
    const bearerToken = "Bearer " + vxm.users.getToken;

    const resp = await axios.post(
      "/wl-profile-svc/api/utmtracker/create",
      payload,
      {
        headers: {
          "Content-Type": "application/json",
          Authorization: bearerToken,
        },
      }
    );
    console.log("utmTrackerId : " + resp.data.utmTrackerId);
    if (resp.data.utmTrackerId) {
      this.setUtmTrackerId(resp.data.utmTrackerId);
    }
    return resp.data.utmTrackerId;
  }
}
